// extracted by mini-css-extract-plugin
module.exports = {"tabs":"newTransferFormTab_tabs__jZHw2"};